import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3100';

/**
 * Record production for a specific line step (manual UI entry).
 * @param {string} token - Auth token
 * @param {{ lineId: string, stepIndex: number, producedNow: number }} opts
 */
export async function recordProductionStep(token, { lineId, stepIndex, producedNow }) {
  const res = await axios.post(
    `${API_URL}/api/production/record`,
    { lineId, stepIndex, producedNow },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res.data;
}

/**
 * Fetch today's daily production totals grouped by outputItemId.
 * Returns a map: { [outputItemId]: totalQuantity }
 * @param {string} token - Auth token
 */
export async function fetchDailyProductionToday(token) {
  const start = new Date();
  start.setUTCHours(0, 0, 0, 0);
  const end = new Date(start);
  end.setUTCHours(23, 59, 59, 999);

  // Use ProductionRecord-derived summary (single source of truth)
  const res = await axios.get(`${API_URL}/api/production-records/summary`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { from: start.toISOString(), to: end.toISOString() },
  });

  const items = res.data?.items || [];
  const map = {};
  items.forEach((it) => {
    const oid = it.outputItemId?._id || it.outputItemId;
    if (!oid) return;
    const k = String(oid);
    map[k] = (map[k] || 0) + (Number(it.quantity) || 0);
  });
  return map;
}
